import { render, staticRenderFns } from "./PartsMain.vue?vue&type=template&id=9a967dc6&scoped=true&"
import script from "./PartsMain.vue?vue&type=script&lang=js&"
export * from "./PartsMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a967dc6",
  null
  
)

export default component.exports